import React from 'react'
import { Route, Switch } from 'react-router'
import ItemPreview from './ItemPreview'
import MainMenu from '../MainMenu'

export default class HistoryRightPanel extends React.Component {
    render(){
        return (
            <Switch>
                <Route path='/history/preview/:id' component={ItemPreview}/>
                <Route component={MainMenu}/>
            </Switch>
        )
    }
}



// WEBPACK FOOTER //
// ./src/layout/Dashboard/RightPanel/History/index.js